import { render, staticRenderFns } from "./ItemPanel.vue?vue&type=template&id=04b2b689&scoped=true&"
import script from "./ItemPanel.vue?vue&type=script&lang=js&"
export * from "./ItemPanel.vue?vue&type=script&lang=js&"
import style0 from "./ItemPanel.vue?vue&type=style&index=0&id=04b2b689&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b2b689",
  null
  
)

export default component.exports